"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _utils = require("../utils");
function useGetWidthElementById(elementId) {
  const [width, setWidth] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    if ((0, _utils.isBrowser)() && document.readyState === 'complete') {
      const el = document.getElementById(elementId);
      if (el) setWidth(el.offsetWidth);
    }
  }, [elementId]);
  return width;
}
var _default = exports.default = useGetWidthElementById;